import { useAuthStore } from '../../stores/authStore'
import { canAccessMailReview } from './access'

export function useMailReviewAccess() {
  const user = useAuthStore((state) => state.user)
  const freshAuthVerified = useAuthStore(
    (state) => state.freshAuthVerified,
  )

  return canAccessMailReview({ user, freshAuthVerified })
}
